import { render, staticRenderFns } from "./KjpChart.vue?vue&type=template&id=2f628542&scoped=true&"
import script from "./KjpChart.vue?vue&type=script&lang=js&"
export * from "./KjpChart.vue?vue&type=script&lang=js&"
import style0 from "./KjpChart.vue?vue&type=style&index=0&id=2f628542&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f628542",
  null
  
)

export default component.exports